export const PROFILE_INFO = {
  DEFAULT_START_PAGE: 1,
  PAGE_SIZE: 40,
  SOURCE_BIRTHDAY_DATE_FORMAT: 'yyyy-MM-dd',
  TARGET_BIRTHDAY_DATE_FORMAT: 'dd.MM.yyyy',
  TARGET_BITHDAY_DATE_REGEX: /^\d{2}\.\d{2}\.\d{4}/
};
